import { render, staticRenderFns } from "./SpectrumDiagramBox.vue?vue&type=template&id=0c1f0554&scoped=true&"
import script from "./SpectrumDiagramBox.vue?vue&type=script&lang=ts&"
export * from "./SpectrumDiagramBox.vue?vue&type=script&lang=ts&"
import style0 from "./SpectrumDiagramBox.vue?vue&type=style&index=0&id=0c1f0554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1f0554",
  null
  
)

export default component.exports